import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Button from '@cotyorg/ccx-atoms/Button';
import { changeTab as changeTabAction } from '../../modules';

export const generateTabClassNames = ({ active, extraClass, extraClassActive }) => classNames('tab__title', {
  'tab__title--active': active,
  [`${extraClass}`]: extraClass,
  [`${extraClassActive}`]: extraClass && active,
});

const TabTitle = ({
  children,
  changeTab,
  active,
  index,
  extraClass,
  extraClassActive,
}) => (
  <Button
    extraClass={generateTabClassNames({ active, extraClass, extraClassActive })}
    onClick={() => changeTab(index)}
  >
    {children}
  </Button>
);

TabTitle.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.bool.isRequired,
  changeTab: PropTypes.func,
  index: PropTypes.number,
  extraClass: PropTypes.string,
  extraClassActive: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  changeTab: index => dispatch(changeTabAction(index)),
});

export default connect(null, mapDispatchToProps)(TabTitle);
